
import { AgGridReact } from 'ag-grid-react'

import React, { useState } from 'react'
import { useAlert } from 'react-alert'
import { Error, Header, Loader } from '../components'
import { useGetComplaintsQuery, useUpdateComplaintsMutation } from '../redux/complaints/complaintApi'
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css'
import { useStateContext } from '../contexts/ContextProvider'

const DropDown = p => {
    const [value, setValue] = useState(p.value)
    return <>
        <select className={`border-[2px]  rounded-lg ${value === 'pending' ? 'bg-red-400' : 'bg-green-400'} text-white`} value={value} name="cars" id="cars"
            onChange={(e) => {
                setValue(e.target.value)
                p.func({
                    id: p.data._id,
                    status: e.target.value
                })
            }}>
            <option value="pending">pending</option>
            <option value="completed">completed</option>

        </select>
        <br />
    </>
}




const Complaints = () => {
    const [complaintsToBeUpdated, setComplaintsToBeUpdated] = useState([])

    const updateHandler = (complaint) => {

        console.log(complaint)


        //checking if we already have the object in list
        const indexOfObject = complaintsToBeUpdated.findIndex(c => {
            return c.id === complaint.id;
        });
        console.log("object found or not ", indexOfObject)
        //if not found then simply add 
        if (indexOfObject === -1) {
            setComplaintsToBeUpdated((prev) => [...prev, complaint])
            return
        }

        //if we are here means that the object existed
        //so delete that 
        setComplaintsToBeUpdated((c) => c.filter((_, index) => index !== indexOfObject));
        console.log("complaints are ", complaintsToBeUpdated)
    }

    const { data, isLoading, error } = useGetComplaintsQuery()
    const { currentMode, currentColor } = useStateContext()
    const [updateComplaints] = useUpdateComplaintsMutation()
    const alert = useAlert()


    const defaultColDefs = {
        sortable: true, filter: true,
    }

    const columnsDefs = [
        {
            field: "status", headerName: "Status", flex: 1.5, cellRenderer: DropDown, cellRendererParams: {
                func: updateHandler
            }
        },
        { field: "complaintType", headerName: "Type", flex: 1 },
        { field: 'user.name', headerName: "User", flex: 2 },
        { field: 'user.address.house', headerName: "🏠", flex: 1 },
        { field: 'user.address.street', headerName: "Street", flex: 1 },
        { field: 'user.address.block', headerName: "Block", flex: 1 },
        { field: 'description', flex: 4 },


    ]
    const onRowClicked = (event) => {
        //console.log(event)
    }

    const handler = () => {
        console.log("the complaints that shall  be updated are ", complaintsToBeUpdated)
        updateComplaints(complaintsToBeUpdated)
        //setting the update complaints to empty again after they have been updated
        setComplaintsToBeUpdated([])
    }

    if (isLoading) return <Loader />

    if (error) {
        alert.error(error.data.message)
        alert.removeAll()
        return <Error />
    }


    return (
        <div className={`m-2 md:m-10 p-2 md:p-10 bg-white rounded-3xl ${currentMode === 'Dark' ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'} h-[500px]`}>
            <Header title="Residents Complaints 📝📝" category="Page" />

            <div className='h-[70%] w-[100%] ' style={{
            }}>
                <AgGridReact rowData={data.complaints} columnDefs={columnsDefs} defaultColDef={defaultColDefs} animateRows={true}
                    onRowClicked={onRowClicked} />
                <button className=' px-3 py-1 border rounded-lg float-right mt-2 font-bold hover:text-white disabled:opacity-25 disabled:hover:text-black' style={{ backgroundColor: `${currentColor}` }} onClick={handler} disabled={complaintsToBeUpdated.length === 0}>update</button>
            </div>
        </div>
    )







}



export default Complaints

